import { Component, Inject } from '@angular/core';
import { BaseSnackbarComponent } from '@app/shared/components/snackbar/base-snackbar.component';
import { MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA } from '@angular/material/legacy-snack-bar';

@Component({
    selector: 'simple-confirm-snackbar',
    templateUrl: './simple-confirm-snackbar.component.html',
    styleUrls: ['./simple-confirm-snackbar.component.scss']
})
export class SimpleConfirmSnackbarComponent extends BaseSnackbarComponent {

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
        super(data);
    }
}
